import { PillsList } from '@hivebrite/design-system/PillsList';

const PublicationCategories = ({ categories }) => (
  <PillsList
    pills={categories}
    seeMoreLabel={s__('Tags|See more')}
    seeLessLabel={s__('Tags|See less')}
  />
);

export default PublicationCategories;
